'use strict';

var _setup = require('./setup.js');

var _ajaxCart = require('./ajax-cart.js');

var _globalUi = require('./global-ui.js');

var cartBuilt = false;

var isFullscreenPanel = function isFullscreenPanel() {
	return _setup.s.$cartPanel.css('display') === 'none';
};

var formatPrices = function formatPrices() {
	return _setup.s.$cartPanel.find('[data-price-tag]').each(_globalUi.formatPriceTags);
};

var animateCartItems = function animateCartItems() {
	var $items = _setup.s.$cartPanel.find('.nx-cartpanel--title, .ajaxcart__product, .ajaxcart__footer');
	TweenMax.staggerFromTo($items, 0.9, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, delay: 0.1, ease: Expo.easeOut }, 0.15);
};

var doPanelOpen = function doPanelOpen() {
	if (_setup._s.menuOverlayShowing) {
		_setup.s.$navModalToggle.trigger('click');
	}

	if (_setup.s.$body.hasClass('is-showing-subnav')) {}

	if (!cartBuilt) {
		_ajaxCart.ajaxCart.load();
		cartBuilt = true;
	} else {
		animateCartItems();
	}

	if (!isFullscreenPanel()) {
		TweenMax.to(_setup.s.$cartOverlay, 0.2, { autoAlpha: 1 });
	}

	TweenMax.set(_setup.s.$cartPanel, { autoAlpha: 1 });
	TweenMax.to(_setup.s.$cartPanel, 0.5, { x: '0%', ease: Expo.easeOut, onComplete: function onComplete() {
			_setup.s.$body.addClass('is-cartpanel-moved');
		} });

	_setup.s.$body.addClass('is-showing-cartpanel');
	_setup._s.cartPanelShowing = true;
};

var doPanelClose = function doPanelClose() {
	_setup.s.$body.removeClass('is-cartpanel-moved');
	TweenMax.to(_setup.s.$cartOverlay, 0.15, { autoAlpha: 0 });

	TweenMax.to(_setup.s.$cartPanel, 0.1, { x: '100%', ease: Expo.easeOut });
	_setup.s.$body.removeClass('is-showing-cartpanel');
	_setup._s.cartPanelShowing = false;
};

var doPanelToggle = function doPanelToggle(e) {
	e.preventDefault();
	if (TweenMax.isTweening(_setup.s.$cartPanel)) return;

	if (!_setup._s.cartPanelShowing) {
		doPanelOpen.call();
	} else {
		doPanelClose.call();
	}
};

_setup.s.$body.on('afterCartLoad.ajaxCart', function () {
	formatPrices();
});

_setup.s.$body.on('afterAddItem.ajaxCart', function () {
	_setup.s.$cartBtn.trigger('click');
});

_setup.s.$cartBtn.click(doPanelToggle);
_setup.s.$cartOverlay.click(doPanelClose);


//////////////////
// WEBPACK FOOTER
// ./_js/cart-panel.js
// module id = 19
// module chunks = 0